export default {
  getStatus (document) {
    if (document.accepted_at === null) {
      return {
        color: 'warning',
        icon: 'fa-warning',
        text: 'Le bon de commande n\'est pas accepté'
      }
    } else {
      return {
        color: 'success',
        icon: 'fa-check',
        text: 'Accepté'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/estimate.js